export default __webpack_public_path__ + "static/media/footer.e0cd4aa0.png";